import { LogLevel } from '../constants/app.constant';

import { ApiConfig, AppConfig as ApplicationConfig, OktaConfig } from '../core';

export class Environment {
  /*********************Properties*********************/
  get appConfig(): ApplicationConfig {
    return this.applicationConfiguration;
  }

  set appConfig(config: ApplicationConfig) {
    this.applicationConfiguration = config;
  }

  get apiConfig(): ApiConfig {
    return this.apiConfiguration;
  }

  set apiConfig(config: ApiConfig) {
    this.apiConfiguration = config;
  }

  get oktaConfig(): OktaConfig {
    return this.oktaConfiguration;
  }

  set oktaConfig(config: OktaConfig) {
    this.oktaConfiguration = config;
  }

  private static instance: Environment;

  private applicationConfiguration: ApplicationConfig = {
    apiKey: '',
    nutracApiKey: '',
    apiTimeOut: '60',
    production: false,
    apiRequestTimeout: '25',
    environment: 'dev',
    nphsWOBannerTopImg: '',
    nphsWOBannerTopUrl: '',
    nphsWOBannerBottomImg: '',
    nphsWOBannerBottomUrl: '',
    wo340BEmailInquires:'',
    restrictInternalUser: false,
    app: {
      comingSoon: false,
      down: false,
      hasError: false,
      loaded: false,
      message: null,
      restrictUserAccess: true
    },
    logger: {
      serverLog: false,
      serverLogLevel: LogLevel.ERROR,
      logLevel: LogLevel.LOG,
    },
    apigeeTokenEndpoint: '',
    oktaIdmLoginUrl: '',
    sonexusRedirectPublicKey: '',

  };

  private apiConfiguration: ApiConfig = {
    config: '',
    login: '',
    order: '',
    user: ''
  };

  private oktaConfiguration: OktaConfig = {
    clientId: '',
    issuer: '',
    scope: '',
    oktaTokenEndpoint: ''
  };
  /*********************Properties*********************/

  /*********************Constructor*********************/
  private constructor() {}
  /*********************Constructor*********************/

  /*********************Methods*********************/

  static getInstance() {
    if (!Environment.instance) {
      Environment.instance = new Environment();
    }

    return Environment.instance;
  }

  /*********************Methods*********************/
}
